import * as React from 'react';
import CannedMessages from '../containers/CannedMessages';

export class Home extends React.Component<{}, {}> {
  render() {
    return (
      <div className="App">
        <CannedMessages />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Home.tsx